import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import ChatPayment from '../../../components/patientApp/patientChat/chatpayment/payment';

const Payment = () => {
    return <Background>
        <ChatPayment />
    </Background>
}
export default Payment;